import {Link} from "react-router-dom";
import {Form, FormFeedback, FormGroup, Label, Input, Button} from "reactstrap";
import Logo from '../../assets/images/BX-LOGO.svg'
import {useState} from "react";
import {useMutation} from "@tanstack/react-query";
import {toast} from "react-toastify";
import { useNavigate } from 'react-router-dom'
import {register} from "../../api/api";
import Loader from "../../components/Loader";


function Register() {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [password1, setPassword1] = useState("");
    const [password2, setPassword2] = useState("");
    const [referrerCode, setReferrerCode] = useState("");
    const [country, setCountry] = useState("IN");
    const [tc, setTc] = useState(false);

    const navigate = useNavigate()

    const registerMutation = useMutation({
        mutationFn: register,
        onSuccess: (data, variables) =>{
            setFirstName('')
            setLastName('')
            setEmail('')
            setPhone('')
            setPassword1('')
            setPassword2('')
            setReferrerCode('')
            setCountry('IN')
            setTc(false)
            navigate("/verification-email-sent", { state: { email } })
            // tokenRefreshMutation.mutate()
            // const newData = {"results":[{'first_name': 'Vamsi'}]}
            // queryClient.setQueryData(['user'], newData)
            toast.success('Registration Successful!')
        },
        onError: err => {
            toast.error(`An error occurred! ${err?.response?.data?.detail}`)
        }
    })

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append("first_name", firstName);
        formData.append("last_name", lastName);
        formData.append("email", email);
        formData.append("phone", phone);
        formData.append("password1", password1);
        formData.append("password2", password2);
        formData.append("referrer_code", referrerCode);
        formData.append("country", country);
        formData.append("tc", tc);
        registerMutation.mutate(formData)
    };

    return (
        <>
            <div className="account-pages mt-5 mb-5">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-8 col-lg-6 col-xl-5">
                            <div className="card">
                                <div className="card-body p-4">
                                    <div className="text-center w-75 m-auto">
                                        <span>
                                            <img
                                                src={Logo}
                                                width="73"
                                                height="56"
                                                alt={Logo}/>
                                        </span>
                                        <p className="text-muted mb-4 mt-3">
                                            Register to create a new BlackX account.
                                        </p>
                                    </div>

                                    <Form onSubmit={handleSubmit}>
                                        <FormGroup className="form-group mb-3">
                                            <Label for="first-name">
                                                First Name
                                                <span className="text-danger">*</span>
                                            </Label>
                                            <Input
                                                className="form-control"
                                                type="text"
                                                id="first-name"
                                                value={firstName}
                                                placeholder="Enter your First Name"
                                                invalid={
                                                    registerMutation.isError &&
                                                    registerMutation.error.response.data.first_name
                                                }
                                                onChange={(e) =>
                                                    setFirstName(e.target.value)
                                                }
                                            />
                                            <FormFeedback invalid>
                                                {
                                                    registerMutation.isError &&
                                                    registerMutation.error.response.data.first_name}
                                            </FormFeedback>
                                        </FormGroup>
                                        <FormGroup className="form-group mb-3">
                                            <Label for="last-name">
                                                Last Name
                                                <span className="text-danger">*</span>
                                            </Label>
                                            <Input
                                                className="form-control"
                                                type="text"
                                                id="last-name"
                                                value={lastName}
                                                placeholder="Enter your Last Name"
                                                invalid={
                                                    registerMutation.isError &&
                                                    registerMutation.error.response.data.last_name
                                                }
                                                onChange={(e) =>
                                                    setLastName(e.target.value)
                                                }
                                            />
                                            <FormFeedback invalid>
                                                {
                                                    registerMutation.isError &&
                                                    registerMutation.error.response.data.last_name}
                                            </FormFeedback>
                                        </FormGroup>
                                        <FormGroup className="form-group mb-3">
                                            <Label for="email-address">
                                                Email address
                                                <span className="text-danger">*</span>
                                            </Label>
                                            <Input
                                                className="form-control"
                                                type="email"
                                                id="email-address"
                                                value={email}
                                                placeholder="Enter your email address"
                                                invalid={
                                                    registerMutation.isError &&
                                                    registerMutation.error.response.data.email
                                                }
                                                onChange={(e) =>
                                                    setEmail(e.target.value)
                                                }
                                            />
                                            <FormFeedback invalid>
                                                {
                                                    registerMutation.isError &&
                                                    registerMutation.error.response.data.email}
                                            </FormFeedback>
                                        </FormGroup>
                                        <FormGroup className="form-group mb-3">
                                            <Label for="phone">
                                                Phone Number
                                                <span className="text-danger">*</span>
                                            </Label>
                                            <Input
                                                className="form-control"
                                                type="text"
                                                id="phone"
                                                value={phone}
                                                placeholder="Enter your phone number (e.g. +919876543210)"
                                                invalid={
                                                    registerMutation.isError &&
                                                    registerMutation.error.response.data.phone
                                                }
                                                onChange={(e) =>
                                                    setPhone(e.target.value)
                                                }
                                            />
                                            <FormFeedback invalid>
                                                {
                                                    registerMutation.isError &&
                                                    registerMutation.error.response.data.phone}
                                            </FormFeedback>
                                        </FormGroup>

                                        <FormGroup className="form-group mb-3">
                                            <Label for="password1">
                                                Password
                                                <span className="text-danger">*</span>
                                            </Label>
                                            <Input
                                                className="form-control"
                                                type="password"
                                                id="password"
                                                value={password1}
                                                placeholder="Enter your password"
                                                invalid={
                                                    registerMutation.isError &&
                                                    registerMutation.error.response.data.password1
                                                }
                                                onChange={(e) =>
                                                    setPassword1(e.target.value)
                                                }
                                            />

                                            <FormFeedback invalid>
                                                {
                                                    registerMutation.isError &&
                                                    registerMutation.error.response.data.password1}
                                            </FormFeedback>
                                        </FormGroup>
                                        <FormGroup className="form-group mb-3">
                                            <Label for="password2">
                                                Confirm Password
                                                <span className="text-danger">*</span>
                                            </Label>
                                            <Input
                                                className="form-control"
                                                type="password"
                                                id="password2"
                                                value={password2}
                                                placeholder="Enter your password again"
                                                invalid={
                                                    registerMutation.isError &&
                                                    registerMutation.error.response.data.password2
                                                }
                                                onChange={(e) =>
                                                    setPassword2(e.target.value)
                                                }
                                            />

                                            <FormFeedback invalid>
                                                {
                                                    registerMutation.isError &&
                                                    registerMutation.error.response.data.password2}
                                            </FormFeedback>
                                        </FormGroup>
                                        <FormGroup className="form-group mb-3">
                                            <Label for="country">
                                                Country
                                                <span className="text-danger">*</span>
                                            </Label>
                                            <select
                                                id="country"
                                                className="form-control mb-2"
                                                value={country}
                                                onChange={(e) =>
                                                    setCountry(e.target.value)
                                                }
                                            >
                                                <option value={"IN"}>India</option>
                                            </select>
                                            <small className="text-muted">
                                                Your Country not in the list?{" "}
                                                <Link to="/waiting-list" className="text-primary font-weight-medium">
                                                    Join waiting list
                                                </Link>{" "}
                                                and we will notify you when we are available in your country
                                            </small>
                                            <FormFeedback invalid>
                                                {
                                                    registerMutation.isError &&
                                                    registerMutation.error.response.data.country}
                                            </FormFeedback>
                                        </FormGroup>
                                        <FormGroup className="form-group mb-3">
                                            <Label for="referrer-code">
                                                Referrer Code
                                            </Label>
                                            <Input
                                                className="form-control"
                                                type="text"
                                                id="referrer-code"
                                                value={referrerCode}
                                                placeholder="Enter your Referrer's code"
                                                invalid={
                                                    registerMutation.isError &&
                                                    registerMutation.error.response.data.referrer_code
                                                }
                                                onChange={(e) =>
                                                    setReferrerCode(e.target.value)
                                                }
                                            />
                                            <FormFeedback invalid>
                                                {
                                                    registerMutation.isError &&
                                                    registerMutation.error.response.data.referrer_code}
                                            </FormFeedback>
                                        </FormGroup>
                                        <FormGroup check>
                                            <Input type="checkbox"
                                                   // className={"custom-control custom-checkbox"}
                                                   onChange={(e) =>
                                                       setTc(e.target.checked)
                                                   }
                                                   invalid={
                                                       registerMutation.isError &&
                                                       registerMutation.error.response.data.tc
                                                   }
                                            />
                                            <Label check>
                                                I accept <Link to={''} className="text-dark">Terms and Conditions <span
                                                className="text-danger">*</span></Link>
                                            </Label>
                                            <FormFeedback invalid>
                                                {
                                                    registerMutation.isError &&
                                                    registerMutation.error.response.data.tc}
                                            </FormFeedback>
                                        </FormGroup>
                                        <FormGroup>
                                            <Button type="submit"
                                                    className="btn bx-btn-primary btn-block waves-effect waves-light mt-2"
                                                    disabled={registerMutation.isLoading}
                                            >
                                                {registerMutation.isLoading? <><Loader size={'small'}/>Registering...</>: `Register`}
                                            </Button>
                                        </FormGroup>
                                    </Form>
                                </div>
                            </div>

                            <div className="row mt-3">
                                <div className="col-12 text-center">
                                    <p className="text-muted">
                                        Already have an account?
                                        <Link
                                            to="/login"
                                            className="text-primary font-weight-medium ml-1"
                                        >
                                            Log In
                                        </Link>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Register;
